<template>
  <div
    class="kt-portlet__head kt-portlet__head--lg"
    :class="{ 'sticky-top': isStickyTop }">
    <div class="kt-portlet__head-toolbar" v-if="showToolbar">
      <ul class="nav nav-tabs nav-tabs-space-xl nav-tabs-line nav-tabs-line-2x nav-tabs-line-info">
        <slot />
      </ul>
    </div>
    <div class="mt-3" v-if="showToolbar"><slot name="buttons"/></div>
    <slot v-if="!showToolbar" />
  </div>
</template>

<script>
export default {
  name: 'TabbedPortletHead',
  props: {
    showToolbar: {
      type: Boolean,
      default: true
    },
    isStickyTop: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style lang="scss" scoped>
.sticky-top {
  position: sticky !important;
  background: white;
  top: 56px;
  z-index: 2;
}
</style>
